import { useEffect } from "react";

declare const heap: any;

// send analytics to heap
export function useUpsellAnalytics(type: string, planName: string) {
  useEffect(() => {
    heap.track("Tax Reports - View - Upsell", {
      type,
      plan: planName,
    });
  }, [type, planName]);
}
